import * as d3 from 'd3';
import { RangeChartPane } from './RangeChartPane';
import { RangeChartPaneConfiguration } from './RangeChartPaneConfiguration';
import { SvgManager } from '../../SvgManager';

export class RangeChart<T, U> {
    private _manager: SvgManager;
    private _panes: RangeChartPane<T, U>[];
    private _isDisabled: boolean;

    constructor(containerName: string) {
        const margins = { marginTop: 10, marginBottom: 10, marginLeft: 10, marginRight: 10 };
        const man = new SvgManager(containerName, margins);

        this._manager = man;
        this._panes = [];
    }

    updatePanes(data: RangeChartPaneConfiguration<T, U>[]) {
        const size = this._manager.getSize();
        const paneHeight = size.height / data.length;
        const panes = [];
        const manager = this._manager;
        const that = this;

        // management of objects and selection might require review
        this._manager.container()
            .selectAll('.pane')
            .remove();
        const dataBound = this._manager.container()
            .selectAll('.pane')
            .data(data);
        dataBound.enter()
            .append('g')
            .classed('pane', true)
            .attr('transform', (d, i) => `translate(${0},${i * paneHeight})`);
        //Do not make use of a lambda: d3 allows to retrieve the element via this if not rescoped
        dataBound.each(function (d, i) {
            //d.height = paneHeight;
            const container = d3.select(this);
            const chartPane = new RangeChartPane(container, size.width, paneHeight);
            chartPane.seriesFormat(d.seriesFormat);
            chartPane.brushCallback(d.brushCallback);
            chartPane.isLockedBrush(d.isLockedBrush);
            chartPane.isBrushDisabled(that._isDisabled);
            chartPane.xDomain(that._xDomain);
            chartPane.onCrosshair(d => that._panes.forEach(p => p.updateCrosshair(d)))
                .updateLines(d.lines ? d.lines : []);
            manager.addResizeFunction((w, h) => {
                chartPane.resize(w, h / data.length);
                container.attr('transform', `translate(${0},${i * h / data.length})`);
            });
            panes.push(chartPane);
        });

        this._panes = panes;
    }

    update(data: any[]) {
        data.forEach(d => d.timeStamp = new Date(d.timeStamp));
        this._panes.forEach(d => d.update(data));
    }

    ranges(ranges: [number, number][]) {
        this._panes.forEach((p, i) => p.range(ranges[i]));
    }

    isDisabled(value: boolean): void {
        if (arguments.length) {
            this._isDisabled = value;
            this._panes.forEach(p => p.isBrushDisabled(value));
        }
    }

    xDomain(xDomain: [string, string]) {
        this._xDomain = xDomain;
        this._panes.forEach(p => p.xDomain(xDomain));
    }

    private _xDomain: [string, string];
}